import { render } from "./reset-form.vue?vue&type=template&id=4e55357c&ts=true"
import script from "./reset-form.vue?vue&type=script&lang=ts"
export * from "./reset-form.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__